package org.teddapp.project.ui.finance

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tedd.db.Finance_account
import org.teddapp.project.ui.TeddIcon
import org.teddapp.project.ui.TeddTokens

/**
 * Le choix d'un compte à débiter : une ligne par compte vivant, sa couleur, son solde.
 * Le même geste pour cocher une ligne de dépenses et pour payer une sous-dépense.
 */
@Composable
internal fun FinanceAccountChips(
    accounts: List<Finance_account>,
    selectedId: String?,
    onSelect: (String) -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(modifier, verticalArrangement = Arrangement.spacedBy(4.dp)) {
        accounts.filter { it.is_deleted == 0L }.forEach { a ->
            val on = a.id == selectedId
            val color = parseFinHex(a.color)
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(TeddTokens.RSm))
                    .background(if (on) color.copy(alpha = 0.08f) else TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
                    .border(1.dp, if (on) color else TeddTokens.Line, RoundedCornerShape(TeddTokens.RSm))
                    .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = { onSelect(a.id) })
                    .padding(horizontal = 10.dp, vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                Box(
                    modifier = Modifier
                        .size(20.dp)
                        .clip(RoundedCornerShape(TeddTokens.RXs))
                        .background(color, RoundedCornerShape(TeddTokens.RXs)),
                    contentAlignment = Alignment.Center,
                ) {
                    TeddIcon(name = a.icon, size = 11.dp, color = TeddTokens.OnAction, strokeWidth = 2.dp)
                }
                Text(
                    text = a.name,
                    color = TeddTokens.Ink,
                    fontSize = 12.5.sp,
                    fontWeight = if (on) FontWeight.SemiBold else FontWeight.Medium,
                    modifier = Modifier.weight(1f),
                )
                Text(text = money(a.balance, a.currency, compact = true), color = TeddTokens.InkMuted, fontSize = 11.5.sp)
            }
        }
    }
}
